/*
* Functions to create and load Notification settings boxes for eSIMs
*
* See notification_settings.liquid and esim-notifications-2.liquid for reference
*/

/*
  * Builds the notification settings checkboxes for a single eSIM
  * 
  * @param {object} esim_info - The ESimInformation object
*/
function buildEsimNotificationCheckboxes(newDiv, esim_info) {
  let esim_name = esim_info.customerRef ? esim_info.customerRef : esim_info.iccid;

  newDiv.className = 'notification_setting_box';

  newDiv.querySelector('#esim_typename').innerHTML = stripDataInfoFromProductName(esim_info.productName) + ' eSIM';
  newDiv.querySelector('#esim_name').innerHTML = '(' + esim_name + ')';
  newDiv.querySelector('#email_toggle').checked = esim_info.notifications.email;
  newDiv.querySelector('#sms_toggle').checked = esim_info.notifications.sms;

  newDiv.querySelector('#esim_ref').value = esim_info.ref || '';
  newDiv.querySelector('#esim_token').value = esim_info.token || '';
  newDiv.querySelector('#esim_iccid').value = esim_info.iccid || '';

  return newDiv;
}
